import ApiError from "./ApiError"
import RequestSender from "./RequestSender"
import {API} from "@simplebooth/webkit"
import {Method} from "./Method"

export default class RequestBuilder {
  url: string
  method: Method | string
  authenticated: boolean = true

  headers: Headers = new Headers()
  body: string | FormData | ArrayBuffer | null = null

  constructor(method: Method | string, endpoint: string, pathOnly: boolean = true) {
    this.method = method
    this.url = pathOnly ? `${API.baseUrl}/api/${endpoint}` : endpoint
  }

  // Requests are authenticated by default
  unauthenticated(): RequestBuilder {
    this.authenticated = false
    return this
  }

  withJson(json: any): RequestBuilder {
    this.body = JSON.stringify(json)
    return this
  }

  withFormData(formData: FormData): RequestBuilder {
    this.body = formData
    return this
  }

  withPlainTextBody(text: string): RequestBuilder {
    this.body = text
    return this
  }

  withHeader(key: string, value: string): RequestBuilder {
    this.headers.append(key, value)
    return this
  }

  withResourceVersion(version: string): RequestBuilder {
    this.headers.append("Accept", version)
    return this
  }

  getTokenValueFromCookie(cookieName: string): string | null {
    // Use a RegExp to find the cookie
    const match = document.cookie.match(new RegExp('(^| )' + cookieName + '=([^;]+)'))
    // If found, decode its value, otherwise return null
    return match ? decodeURIComponent(match[2]) : null
  }

  build(): Request {
    if (this.authenticated) {
      const token = this.getTokenValueFromCookie("token")

      if (!token) {
        // Redirect to log in screen
        window.location.href = process.env.REACT_APP_LEGACY_DASHBOARD_BASE_URL + "/login"

        // Throw an error in case redirect fails for any reason
        throw new ApiError("Missing token for authenticated request.", 0)
      }

      this.headers.append("Authorization", `Token ${token}`)
    }

    try {
      return new Request(this.url, {
        method: this.method,
        headers: this.headers,
        body: this.body,
      })
    } catch (e: any) {
      throw new ApiError(e.message, 0)
    }
  }

  async buildAndSend(): Promise<any> {
    return RequestSender.sendRequest(this.build())
  }
}